import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./articleLikeState.modules.less";
import { article } from "@Api";
import { message } from "antd";

const { fetchEquipMovieLikeStatus, fetchLike } = article;

const Content = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [likedState, setLikedState] = useState({
    static: {
      likes: 0,
      unlikes: 0,
    },
    status: {
      liked: 0,
      unliked: 0,
    },
  });

  const fetchLikeState = async () => {
    try {
      const res: { data; status } = await fetchEquipMovieLikeStatus({
        id: window?.article?.id,
        model: window?.article?.type === 1 ? "article" : "trialart",
      });
      if (res.status === 12000) {
        setLikedState(res.data);
      }
    } catch (error) {}
  };

  const handleClickLike = async (type) => {
    if (isLoading) {
      message.warning("請勿重複點擊！");
      return;
    }
    setIsLoading(true);
    try {
      await fetchLike({
        action: type,
        id: window?.article?.id,
        model: window?.article?.type === 1 ? "article" : "trialart",
      });
      setLikedState((prevState) => {
        const isLikeAction = type === "like";
        return {
          static: {
            likes: isLikeAction ? prevState.static.likes + 1 : prevState.static.likes,
            unlikes: isLikeAction ? prevState.static.unlikes : prevState.static.unlikes + 1,
          },
          status: {
            liked: isLikeAction ? 1 : prevState.status.liked,
            unliked: isLikeAction ? prevState.status.unliked : 1,
          },
        };
      });
    } catch (error) {}
  };

  useEffect(() => {
    fetchLikeState();
  }, []);

  useEffect(() => {
    (likedState?.status?.liked == 1 || likedState?.status?.unliked == 1) && setIsLoading(true);
  }, [likedState]);

  return (
    <section className={styles["article-like"]}>
      <div
        className={styles["item"]}
        onClick={() => {
          handleClickLike("like");
        }}
      >
        {likedState?.status?.liked === 0 ? (
          <img className={styles["img"]} src='https://photo.8891.com.tw/2023/08/31/1693465319204272.png' alt='' />
        ) : (
          <img className={styles["img"]} src='https://photo.8891.com.tw/2023/09/11/1694400611561354.png' alt='' />
        )}
        <span className={styles["text"]}>
          {likedState?.static?.likes === 0 ? "好文章，鼓勵一下" : likedState?.static?.likes ?? 0}
        </span>
      </div>
      <div
        className={styles["item"]}
        onClick={() => {
          handleClickLike("unlike");
        }}
      >
        {likedState?.status?.unliked === 0 ? (
          <img className={styles["img"]} src='https://photo.8891.com.tw/2023/08/31/1693465319015331.png' alt='' />
        ) : (
          <img className={styles["img"]} src='https://photo.8891.com.tw/2023/09/11/1694400611722394.png' alt='' />
        )}
        <span className={styles["text"]}>
          {likedState?.static?.unlikes === 0 ? "對我幫助不大" : likedState?.static?.unlikes ?? 0}
        </span>
      </div>
    </section>
  );
};

const $app = document.getElementById("articles-like-state");
!!$app && ReactDOM.render(<Content />, $app);
